<template lang="pug">
  v-layout
    v-card.box-card-mis-seguros-formatter
      v-card-text
        v-layout(column align-center)
          v-flex(style="padding-top: 1em;")
            v-img
              img(
                style="height:150px;width:150px"
                :src="icon"
                )
          v-flex
            span(style="font-weight: 600;font-size: 24px;color: #0855C4;margin: 0.5em 0em") {{titulo || '¡Hola!'}}
          v-flex(style="text-align: center;height: 8em;margin: 5px 5px")
            span(style="font-size:14px;color:#535D66;line-height:normal") {{mensaje}}
          v-flex(style="width:100%")
            v-layout(row)
              v-flex(xs5 style="align-self: center;")
                .box-guia-formatter
                  div.box-point(@click="sliderPopup()")
                  div.box-point(@click="sliderPopup(1)")
                  div.box-point(@click="sliderPopup(2)")
                  div.box-point(v-if="!(oriProducto || '').includes('VIDA_CASH_PLUS')" @click="sliderPopup(3)")
              v-flex(style="align-self: center;")
                span.box-salir-tooltip(
                  style="display: flex;justify-content: center;color: #454A6C;font-size: 16px;cursor:pointer"
                  @click="sliderPopup(flagSlider, false)"
                  ) Atrás
              v-flex
                v-btn(style="background: #EA0D90;" @click="sliderPopup(flagSlider,true)" )
                  span(style="color:#ffffff; text-transform: capitalize;") Siguiente
</template>

<script>

export default {
  props: [
    'producto',
    'oriProducto'
  ],
  data () {
    return {
      titulo: '',
      icon: require('@/assets/characters/informa.svg'),
      flag1: false,
      flag2: false,
      flag3: false,
      flagSlider: 0,
      pg: {
        plan: 'En esta sección podrás consultar y gestionar tus seguros de manera rápida y sencilla.',
        hoy: 'Aquí encontrarás, como va tu seguro a la fecha.',
        proyeccion: 'Aquí podrás visualizar tus montos de ahorro a futuro.',
        hola: 'Te enseñamos a descubrir como usar lo nuevo de Mis Seguros'
      },
      vf: {
        plan: 'En esta sección podrás consultar y gestionar tus seguros de manera rápida y sencilla.',
        hoy: 'Aquí encontrarás, como va tu seguro a la fecha.',
        proyeccion: 'Aquí podrás visualizar el crecimiento de tus ahorros más tu rentabilidad en el futuro.',
        hola: 'Te enseñamos a descubrir como usar lo nuevo de Mis Seguros.'
      },
      auxMessage: {},
      mensaje: ''
    }
  },
  methods: {
    sliderPopup (item = 0, beforeToNextTooltip = false) {
      const vidaCashPlus = (this.oriProducto || '').includes('VIDA_CASH_PLUS')
      let points = document.querySelectorAll('.box-guia-formatter .box-point')
      if (points.length === 0) {
        return
      }
      this.flag1 = false
      this.flag2 = false
      this.flag3 = false
      points[0].style.background = '#D9D9D9'
      points[1].style.background = '#D9D9D9'
      points[2].style.background = '#D9D9D9'
      if (!vidaCashPlus) {
        points[3].style.background = '#D9D9D9'
      }
      if (vidaCashPlus) {
        item = item >= 2 && beforeToNextTooltip ? item + 1 : item === 0 && !beforeToNextTooltip ? 3 : item
      }
      item = (beforeToNextTooltip) ? ((item + 1 < 4) ? item + 1 : 0) : ((item - 1 >= 0) ? item - 1 : 3)

      this.flagSlider = item
      switch (item) {
      case 1:
        this.flag1 = true
        points[1].style.background = '#0855C4'
        this.titulo = 'Plan'
        this.mensaje = this.auxMessage.plan
        this.icon = require('./../../assets/icons-mis-seguros/icon-mis-seguros-plan.svg')
        break
      case 2:
        this.flag2 = true
        points[2].style.background = '#0855C4'
        this.titulo = 'Hoy'
        this.mensaje = this.auxMessage.hoy
        this.icon = require('./../../assets/icons-mis-seguros/icon-mis-seguros-hoy.svg')
        break
      case 3:
        this.flag3 = true
        points[3].style.background = '#0855C4'
        this.titulo = 'Proyección'
        this.mensaje = this.auxMessage.proyeccion
        this.icon = this.producto !== 'PLANGARANTIZADO' ? require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf1.svg') : require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion.svg')
        break
      default:
        points[0].style.background = '#0855C4'
        this.titulo = '¡Hola!'
        this.mensaje = this.auxMessage.hola
        this.icon = require('@/assets/characters/informa.svg')
        break
      }
    }

  },
  mounted () {
    this.sliderPopup(3, true)
    if (this.producto !== 'PLANGARANTIZADO') {
      this.auxMessage = { ...this.vf }
    } else {
      this.auxMessage = { ...this.pg }
    }
    this.mensaje = this.auxMessage.hola
  }
}
</script>

<style scoped>
.box-card-mis-seguros-formatter {
  border-radius: 14px;
  width: 251px;
  box-shadow: none;
  border: 1px solid #C4C4C4;
}

.box-guia-formatter {
  display: flex;
  padding-left: 1.5em;
}

.box-guia-formatter div {
  height: 6px;
  width: 6px;
  border-radius: 3px;
  margin-right: 5px;
  background: #D9D9D9;

}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/GuiaMisSeguros.vue